import { z } from 'zod';

export const productionModuleSchema = z
  .object({
    /**
     * Change timeline time offset:
     * eg. -1 for Sanok will produce 07:00, 15:00 and 23:00 instead of 08:00, 16:00 and 00:00
     */
    timelineTimeOffset: z.number().default(0),
    /**
     * Enable 'Worker Mode' view for Gantt
     */
    workerModeView: z.boolean().default(false),
    workerModeViewShifts: z
      .array(
        z.object({
          nameKey: z.enum(['shift1', 'shift2', 'shift3']),
          from: z.string(),
          to: z.string(),
          endNextDay: z.boolean().default(false),
          shortName: z.string().default(''),
        }),
      )
      .default([
        { nameKey: 'shift1', from: '06:30', to: '14:30', shortName: 'I' },
        { nameKey: 'shift2', from: '14:30', to: '22:30', shortName: 'II' },
        { nameKey: 'shift3', from: '22:30', to: '06:30', endNextDay: true, shortName: 'III' },
      ]),
    /**
     * Enable 'Simulation' view for Gantt
     */
    simulationView: z.boolean().default(false),
    /**
     * Enable simulations list view for Gantt
     */
    simulationListView: z.boolean().default(false),
    /**
     * Enable simulation validation
     */
    planValidation: z.boolean().default(false),
    /**
     * Enable button for manually run auto-plan
     */
    autoPlan: z.boolean().default(false),
    /**
     * Enable month scale in Gantt
     */
    ganttMonthScale: z.boolean().default(false),
    /**
     * Enable sync button in Gantt - NEX-2751
     */
    syncButton: z.boolean().default(false),
    /**
     * Enable left/right graph expansion buttons on dependency graph nodes
     */
    graphExpand: z.boolean().default(false),
  })
  .default({});
